// @ts-strict-ignore
import { ArticleUsageVO } from '@article/model/vo/article.vo';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { ProjectArticleService } from '@project/service/project-article.service';

export class BaseArticleHelper {
  protected _baseArticleType: string = null;

  constructor(
    protected projectArticleService: ProjectArticleService,
    protected containerService: ContainerService
  ) {}

  protected getBaseArticleUsage(): ArticleUsageVO {
    if (!this._baseArticleType) {
      return null;
    }
    const baseArticleUsages: ArticleUsageVO[] = this.projectArticleService.findArticleUsagesByType(this._baseArticleType);
    return baseArticleUsages.length > 0 ? baseArticleUsages[0] : null;
  }

  protected getBaseArticleContainer(): ArticleContainer {
    const baseUsage: ArticleUsageVO = this.getBaseArticleUsage();
    if (!baseUsage) {
      return null;
    }
    return this.containerService.findArticleContainerInGlobal(baseUsage.id);
  }
}
